export default __webpack_public_path__ + "static/media/blockchainIcon.699a94b8.webp";